@use '../../../app/styles/common/mixins';

$row-height-tablet: 17px;
$row-height-laptop: 19px;
$max-rows: 3;

@mixin link-typography {
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: $row-height-tablet;

  @include mixins.laptop {
    font-size: 16px;
    line-height: $row-height-laptop;
  }
}

.container {
  display: flex;
  width: calc(100% + var(--spasing16));
  gap: var(--spasing24);
  margin-top: var(--spasing12);

  // Category links → chips row = 16px on phones, provided by .mainContent's margin-top
  margin-bottom: 0;
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  white-space: nowrap;

  &::-webkit-scrollbar {
    display: none;
  }

  @include mixins.tablet {
    width: 100%;
    flex-wrap: wrap;
    gap: var(--spasing12) var(--spasing32);
    margin-top: var(--spasing16);
    margin-bottom: var(--spasing24);
    overflow-x: visible;
    white-space: normal;

    // 3 rows until the client measures; keeps the SSR paint = collapsed layout.
    // Dropped once measured: hidden items already clamp the rows, and a title wrapping onto
    // a second line must not be cut off.
    &.collapsed:not(.measured) {
      max-height: calc(#{$max-rows} * #{$row-height-tablet} + #{$max-rows - 1} * var(--spasing12));
      overflow: hidden;
    }
  }

  @include mixins.laptop {
    &.collapsed:not(.measured) {
      max-height: calc(#{$max-rows} * #{$row-height-laptop} + #{$max-rows - 1} * var(--spasing12));
    }
  }

  // Nested to beat the Button atom's size/variant classes.
  .showMore {
    gap: var(--spasing04);
    height: $row-height-tablet;
    min-width: 0;
    padding: 0;
    border: 0;
    color: var(--fg-info);

    @include link-typography;

    @include mixins.laptop {
      height: $row-height-laptop;
    }

    // Same recipe as the Button text variant (fg → fg-action); focus ring comes from the atom.
    &:hover {
      color: var(--fg-action-info);
    }
  }
}

.link {
  display: inline-flex;
  gap: var(--spasing04);
  align-items: baseline;
  color: var(--fg-primary);
  text-decoration: none;

  @include link-typography;

  // The class's display beats the UA [hidden] rule.
  &[hidden] {
    display: none;
  }
}

.count {
  font-weight: 400;
  color: var(--fg-secondary);
}

.pending {
  visibility: hidden;
}
